import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initializeMonitoring, MonitoringErrorBoundary } from "./lib/monitoring";
import "./styles.css";

initializeMonitoring();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MonitoringErrorBoundary>
      <App />
    </MonitoringErrorBoundary>
  </React.StrictMode>
);
